import * as yup from 'yup';

export const createReferralPositionSubscriptionValidationSchema = yup.object({
  email: yup
    .string()
    .email('Invalid email format')
    .required('Email is required')
    .nullable(),
  frequency: yup.string().required('Frequency is required').nullable(),
});
